module.exports = __webpack_public_path__ + "static/car-024a8284b442904e863f86c99d814cc4.png";